import getConfig from "next/config";
import { YMInitializer } from "react-yandex-metrika";
import { usePageLoaded } from "helpers/hooks";

const { publicRuntimeConfig } = getConfig();

type Props = { options: Record<string, any> };

const YandexMetrica: React.FC<Props> = ({ options }: Props) => {
  const loaded = usePageLoaded();
  const { Y_METRICA } = publicRuntimeConfig;

  if (!Y_METRICA || !loaded) return null;

  return <YMInitializer accounts={[Number(Y_METRICA)]} options={options} />;
};

export default YandexMetrica;
